import { jsx as _jsx } from "react/jsx-runtime";
/*eslint no-useless-escape: 0*/
import React from 'react';
import { ROUTES, FUNCIONALIDADES } from '../../../../routes';
import { getInstituicaoDocumentos, getInstituicaoDocumentoVisualizacaoURL, cadastrarInstituicaoDocumento, alterarInstituicaoDocumento, excluirInstituicaoDocumento, getInstituicoesTiposTermosDocumentosAtivos, } from '../../../../api';
import { DocumentosAnexosBaseForm } from '../../../../components/DocumentosAnexosBaseForm';
import { getTokenFromCookie } from '../../../../services/mt_login';
var InstituicoesDocumentos = function (props) {
    var setAbaAtiva = props.setAbaAtiva, fluxoCadastro = props.fluxoCadastro;
    var services = {
        getTipos: getInstituicoesTiposTermosDocumentosAtivos,
        getItens: getInstituicaoDocumentos,
        cadastrarItem: cadastrarInstituicaoDocumento,
        alterarItem: alterarInstituicaoDocumento,
        excluirItem: excluirInstituicaoDocumento,
        getVisualizacaoURL: function (idDoc) { return getInstituicaoDocumentoVisualizacaoURL(idDoc, getTokenFromCookie()); },
    };
    return (_jsx(DocumentosAnexosBaseForm, { pagina: FUNCIONALIDADES.CC_INSTITUICOES_DOCUMENTOS, rotaVoltar: ROUTES.CC_INSTITUICOES, services: services, tipoIdField: 'tipo_termo_documento_id', listaDocumentosField: 'documentos', abaVoltar: 0, setAbaAtiva: setAbaAtiva, fluxoCadastro: fluxoCadastro }));
};
export default InstituicoesDocumentos;
